import API from '@edulastic/api/src/utils/API'
import qs from 'qs'
import { paramsSerializer } from '../../datawarehouse/utils'

const api = new API()

const testActivityPrefix = '/test-activity'
const reportsPrefix = '/report'
const dataWarehousePrefix = '/data-warehouse'
const goalsAndInterventionsPrefix = '/goals-interventions'

const fetchReports = (
  groupId = '',
  testId = '',
  assignmentId = '',
  groupStatus = 'all'
) => {
  const config = {
    url: `${testActivityPrefix}/summary`,
    method: 'get',
    params: {
      groupId,
      groupStatus,
      testId,
      assignmentId,
    },
    useSlowApi: true,
  }

  return api.callApi(config).then((result) => result.data.result)
}

const fetchTestActivityDetail = (id) =>
  api
    .callApi({
      url: `${testActivityPrefix}/${id}`,
      method: 'get',
    })
    .then((result) => result)

const fetchTestActivityReport = (id, groupId) =>
  api
    .callApi({
      url: `${testActivityPrefix}/${id}/report`,
      method: 'get',
      params: {
        groupId,
      },
      useSlowApi: true,
    })
    .then((result) => result.data.result)

const fetchAssignments = () => api.callApi({ url: `/assignments` })

const fetchResponseFrequency = (params) =>
  api.callApi({
    useSlowApi: true,
    url: `${reportsPrefix}/response-frequency`,
    params: { ...params.requestFilters, testId: params.testId },
  })

const fetchAssessmentSummaryReport = (params) =>
  api.callApi({
    useSlowApi: true,
    url: `${reportsPrefix}/assessment-summary`,
    params: { ...params.requestFilters, testId: params.testId },
  })

const fetchPeerPerformanceReport = (params) =>
  api.callApi({
    useSlowApi: true,
    url: `${reportsPrefix}/peer-performance`,
    params: { ...params.requestFilters, testId: params.testId },
  })

const fetchPerformanceByStandardSummary = (params) =>
  api.callApi({
    useSlowApi: true,
    url: `${reportsPrefix}/performance-by-standards/summary`,
    params: { ...params.requestFilters, testId: params.testId },
  })

const fetchPerformanceByStandardDetails = (params) =>
  api.callApi({
    useSlowApi: true,
    url: `${reportsPrefix}/performance-by-standards/details`,
    params: { ...params.requestFilters, testId: params.testId },
  })

const fetchPerformanceByStudentsSummary = (params) =>
  api.callApi({
    useSlowApi: true,
    url: `${reportsPrefix}/performance-by-students/summary`,
    params: { ...params.requestFilters, testId: params.testId },
  })

const fetchPerformanceByStudentsDetails = (params) =>
  api.callApi({
    useSlowApi: true,
    url: `${reportsPrefix}/performance-by-students/details`,
    params: { ...params.requestFilters, testId: params.testId },
  })

const fetchFilterDefaults = (params) =>
  api
    .callApi({
      url: `${dataWarehousePrefix}/filter/defaults`,
      params,
    })
    .then((r) => r.data)

const fetchSARFilterData = (params) =>
  api.callApi({
    useSlowApi: true,
    url: `${reportsPrefix}/filter/single-assessment`,
    params,
  })

const fetchStandardsGradbookSkillInfo = (params) =>
  api.callApi({
    useSlowApi: true,
    url: `${reportsPrefix}/standards-gradebook/skill-info`,
    params,
  })

const fetchStandardsGradebookSummary = (params) =>
  api.callApi({
    useSlowApi: true,
    url: `${reportsPrefix}/standards-gradebook/summary`,
    params,
  })

const fetchStandardsGradebookDetails = (params) =>
  api.callApi({
    useSlowApi: true,
    url: `${reportsPrefix}/standards-gradebook/details`,
    params,
  })

const fetchStandardsPerformanceSummaryReport = (params) =>
  api.callApi({
    useSlowApi: true,
    url: `${reportsPrefix}/standards-summary`,
    params,
  })

const fetchStandardMasteryFilter = (params) =>
  api.callApi({
    useSlowApi: true,
    url: `${reportsPrefix}/filter/standard-mastery`,
    params,
  })

const fetchStandardMasteryBrowseStandards = ({
  curriculumId,
  ...restParams
}) => {
  const curriculumIds =
    curriculumId && Array.isArray(curriculumId) ? curriculumId : [curriculumId]

  const data = {
    ...restParams,
    curriculumIds,
  }

  return api.callApi({
    url: `/search/browse-standards`,
    data,
    method: 'POST',
    useSlowApi: true,
  })
}

const fetchQuestionAnalysisSummaryReport = (params) =>
  api
    .callApi({
      useSlowApi: true,
      url: `${reportsPrefix}/question-analysis/summary`,
      params,
    })
    .then((response) => response.data.result)

const fetchQuestionAnalysisPerformanceReport = (params) =>
  api
    .callApi({
      useSlowApi: true,
      url: `${reportsPrefix}/question-analysis/details`,
      params,
    })
    .then((response) => response.data.result)

const fetchMARFilterData = (params) =>
  api.callApi({
    useSlowApi: true,
    url: `${reportsPrefix}/filter/multiple-assessment`,
    params,
  })

const fetchCompletionReportChart = (params) =>
  api.callApi({
    useSlowApi: true,
    url: `${reportsPrefix}/completion/chart`,
    params,
  })

const fetchCompletionReportTable = (params) =>
  api.callApi({
    useSlowApi: true,
    url: `${reportsPrefix}/completion/table`,
    params,
  })

const fetchPeerProgressAnalysisReport = (params) =>
  api.callApi({
    useSlowApi: true,
    url: `${reportsPrefix}/peer-progress-analysis`,
    params,
  })

const fetchStudentProgressReport = (params) =>
  api.callApi({
    useSlowApi: true,
    url: `${reportsPrefix}/student-progress`,
    params,
  })

const fetchPerformanceOverTimeReport = (params) =>
  api.callApi({
    useSlowApi: true,
    url: `${reportsPrefix}/performance-over-time`,
    params,
  })

const fetchSPRFilterData = (params) =>
  api.callApi({
    useSlowApi: true,
    url: `${reportsPrefix}/filter/student-profile`,
    params,
    paramsSerializer,
  })

const fetchStudentMasteryProfileReport = (params) =>
  api.callApi({
    useSlowApi: true,
    url: `${reportsPrefix}/student-mastery-profile`,
    params,
  })

const fetchStudentAssessmentProfileReport = (params) =>
  api.callApi({
    useSlowApi: true,
    url: `${reportsPrefix}/student-assessment-performance`,
    params,
  })

const fetchStudentProfileSummaryReport = (params) =>
  api.callApi({
    useSlowApi: true,
    url: `${reportsPrefix}/student-profile-summary`,
    params,
  })

const fetchStudentProgressProfileReport = (params) =>
  api.callApi({
    useSlowApi: true,
    url: `${reportsPrefix}/student-progress-profile`,
    params,
  })

const fetchStudentList = (params) =>
  api.callApi({
    useSlowApi: true,
    url: `${reportsPrefix}/students`,
    method: 'POST',
    data: params,
  })

const fetchStudentStandards = (params) =>
  api.callApi({
    useSlowApi: true,
    url: `${reportsPrefix}/student-standard`,
    params,
  })

const fetchStudentPerformance = (params) => {
  const queryString = qs.stringify(params)
  return api
    .callApi({
      useSlowApi: true,
      method: 'get',
      url: `${reportsPrefix}/student-performance?${queryString}`,
    })
    .then(({ data }) => data.result)
}

const fetchEngagementSummary = (params) =>
  api.callApi({
    useSlowApi: true,
    url: `${reportsPrefix}/engagement-summary`,
    params,
  })

const fetchActivityBySchool = (params) =>
  api.callApi({
    useSlowApi: true,
    url: `${reportsPrefix}/activity-by-school`,
    params,
  })

const fetchActivityByTeacher = (params) =>
  api.callApi({
    useSlowApi: true,
    url: `${reportsPrefix}/activity-by-teacher`,
    params,
  })

const generateCSV = (params) =>
  api
    .callApi({
      url: `${reportsPrefix}/generate-csv`,
      method: 'POST',
      data: params,
      useSlowApi: true,
    })
    .then(({ data }) => data.result)

const fetchGeneratedCSVs = () =>
  api
    .callApi({
      url: `${reportsPrefix}/generated-csv`,
      method: 'GET',
      useSlowApi: true,
    })
    .then(({ data }) => data.result)

const fetchPerformanceByRubricsCriteriaChartData = (params) =>
  api
    .callApi({
      url: `${reportsPrefix}/performance-by-rubric/chart`,
      params,
      useSlowApi: true,
    })
    // FIXME remove `.result` which doesn't contain dataSize error
    .then((res) => res.data.result)

const fetchPerformanceByRubricsCriteriaTableData = (params) =>
  api
    .callApi({
      url: `${reportsPrefix}/performance-by-rubric/table`,
      params,
      useSlowApi: true,
    })
    // FIXME remove `.result` which doesn't contain dataSize error
    .then((res) => res.data.result)

const fetchPreVsPostReportSummaryData = (params) =>
  api
    .callApi({
      url: `${reportsPrefix}/pre-vs-post-test/summary`,
      params,
      useSlowApi: true,
    })
    .then((res) => res.data)

const fetchPreVsPostReportTableData = (params) =>
  api
    .callApi({
      url: `${reportsPrefix}/pre-vs-post-test/table`,
      params,
      useSlowApi: true,
    })
    .then((res) => res.data)

const fetchAttendanceReportDetails = (params) =>
  api
    .callApi({
      url: `${dataWarehousePrefix}/attendance/report/details`,
      params,
      useSlowApi: true,
    })
    .then((response) => response?.data?.result)

const fetchAttendanceSummaryReport = (params) =>
  api
    .callApi({
      url: `${dataWarehousePrefix}/attendance/report`,
      params,
      useSlowApi: true,
    })
    .then((response) => response?.data?.result)

const fetchAttendanceDistributionReport = (params) =>
  api
    .callApi({
      url: `${dataWarehousePrefix}/attendance/distribution`,
      params,
      useSlowApi: true,
    })
    .then((response) => response?.data?.result)

const createGoal = (data) =>
  api
    .callApi({
      url: `${dataWarehousePrefix}${goalsAndInterventionsPrefix}/goals`,
      method: 'post',
      data,
    })
    .then((response) => response?.data?.result)

const createIntervention = (data) =>
  api
    .callApi({
      url: `${dataWarehousePrefix}${goalsAndInterventionsPrefix}/interventions`,
      method: 'post',
      data,
    })
    .then((response) => response?.data?.result)

const updateGoal = (id, data) =>
  api
    .callApi({
      url: `${dataWarehousePrefix}${goalsAndInterventionsPrefix}/goals/${id}`,
      method: 'put',
      data,
    })
    .then((response) => response?.data?.result)

const updateIntervention = (id, data) =>
  api
    .callApi({
      url: `${dataWarehousePrefix}${goalsAndInterventionsPrefix}/interventions/${id}`,
      method: 'put',
      data,
    })
    .then((response) => response?.data?.result)

const deleteGoal = (id) =>
  api
    .callApi({
      url: `${dataWarehousePrefix}${goalsAndInterventionsPrefix}/goals/${id}`,
      method: 'delete',
    })
    .then((response) => response?.data?.result)

const deleteIntervention = (id) =>
  api
    .callApi({
      url: `${dataWarehousePrefix}${goalsAndInterventionsPrefix}/interventions/${id}`,
      method: 'delete',
    })
    .then((response) => response?.data?.result)

const getGoals = () =>
  api
    .callApi({
      url: `${dataWarehousePrefix}${goalsAndInterventionsPrefix}/goals`,
      method: 'get',
      useSlowApi: true,
    })
    .then((response) => response?.data?.result)

const fetchAttendanceBands = () =>
  api
    .callApi({
      url: `${dataWarehousePrefix}${goalsAndInterventionsPrefix}/attendance-band`,
      method: 'get',
      useSlowApi: true,
    })
    .then((result) => result.data.result)

const getInterventions = (params) =>
  api
    .callApi({
      url: `${dataWarehousePrefix}${goalsAndInterventionsPrefix}/interventions`,
      method: 'get',
      params,
      paramsSerializer: (param) => qs.stringify(param),
      useSlowApi: true,
    })
    .then((response) => response?.data?.result)

const getReportInterventions = (params) => {
  return api
    .callApi({
      url: `${dataWarehousePrefix}${goalsAndInterventionsPrefix}/report-interventions`,
      method: 'get',
      params: { jsonQuery: JSON.stringify(params) },
      useSlowApi: true,
    })
    .then((response) => response?.data?.result?.responseData)
}

const getCsvData = (params) =>
  api.callApi({
    url: `${reportsPrefix}/completion/generate-csv`,
    method: 'get',
    params,
  })

const fetchDemographicsByOrg = () => {
  return api.callApi({
    url: `${reportsPrefix}/demographics-by-org`,
    method: 'get',
    useSlowApi: true,
  })
}

const getAISummary = (params) =>
  api
    .callApi({
      url: `${reportsPrefix}/ai-summary`,
      method: 'post',
      data: params,
    })
    .then((response) => response.data)

const fetchProfileFilterData = (params) =>
  api.callApi({
    useSlowApi: true,
    url: `${reportsPrefix}/filter/profile`,
    params,
  })

const fetchClassProfileReport = (params) =>
  api.callApi({
    useSlowApi: true,
    url: `${reportsPrefix}/class-profile`,
    params,
  })

const fetchStudentProfileReportData = (params) =>
  api.callApi({
    useSlowApi: true,
    url: `${reportsPrefix}/student-profile`,
    params,
  })

export default {
  fetchReports,
  fetchTestActivityDetail,
  fetchTestActivityReport,
  fetchAssignments,
  fetchResponseFrequency,
  fetchAssessmentSummaryReport,
  fetchPeerPerformanceReport,
  fetchPerformanceByStandardSummary,
  fetchPerformanceByStandardDetails,
  fetchPerformanceByStudentsSummary,
  fetchPerformanceByStudentsDetails,
  fetchFilterDefaults,
  fetchSARFilterData,
  fetchMARFilterData,
  fetchSPRFilterData,
  fetchStandardsGradbookSkillInfo,
  fetchStandardsGradebookSummary,
  fetchStandardsGradebookDetails,
  fetchStandardsPerformanceSummaryReport,
  fetchStandardMasteryFilter,
  fetchStandardMasteryBrowseStandards,
  fetchQuestionAnalysisSummaryReport,
  fetchQuestionAnalysisPerformanceReport,
  fetchPeerProgressAnalysisReport,
  fetchStudentProgressReport,
  fetchPerformanceOverTimeReport,
  fetchStudentMasteryProfileReport,
  fetchStudentAssessmentProfileReport,
  fetchStudentProfileSummaryReport,
  fetchStudentProgressProfileReport,
  fetchStudentList,
  fetchStudentStandards,
  fetchStudentPerformance,
  fetchEngagementSummary,
  fetchActivityBySchool,
  fetchActivityByTeacher,
  generateCSV,
  fetchGeneratedCSVs,
  fetchPerformanceByRubricsCriteriaChartData,
  fetchPerformanceByRubricsCriteriaTableData,
  fetchPreVsPostReportSummaryData,
  fetchPreVsPostReportTableData,
  fetchAttendanceReportDetails,
  fetchAttendanceSummaryReport,
  fetchAttendanceDistributionReport,
  createGoal,
  createIntervention,
  getGoals,
  fetchAttendanceBands,
  getInterventions,
  getReportInterventions,
  deleteGoal,
  deleteIntervention,
  updateGoal,
  updateIntervention,
  fetchCompletionReportChart,
  fetchCompletionReportTable,
  getCsvData,
  fetchDemographicsByOrg,
  getAISummary,
  fetchProfileFilterData,
  fetchClassProfileReport,
  fetchStudentProfileReportData,
}
